import script from "./NotificationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationHeader.vue?vue&type=script&setup=true&lang=js"

import "./NotificationHeader.vue?vue&type=style&index=0&id=5e225201&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e225201"]])

export default __exports__